/**
 * The dismiss button every panel needs: an `IconButton` with the cross.
 *
 * Replaced seven near-identical implementations, which settled the glyph (the
 * family's cross, not a text `✕` or `×`) and the fact that every one needs an
 * accessible name, which the type requires. Vesper made it round, like every
 * other icon-only control.
 *
 *   variant  quiet     transparent until hovered — a panel that already has a surface
 *            floating  a translucent wash — a translucent header, where a
 *                      transparent button would vanish
 */

import { GLYPH } from './glyphs';
import { Icon } from './icon';
import { IconButton } from './icon-button';
import type { IconButtonProps } from './icon-button';

/** The cross says what it does, so it takes no tip; and a way to close never rests. */
type CloseButtonProps = Omit<IconButtonProps, 'children' | 'size' | 'tip' | 'reason'>;

export function CloseButton({ variant = 'quiet', ...rest }: CloseButtonProps) {
  return (
    <IconButton variant={variant} size="sm" {...rest}>
      <Icon glyph={GLYPH.close} size="sm" />
    </IconButton>
  );
}
